module.exports = __webpack_public_path__ + "media/images/icons/twotone/delete-762a07886f8203207dc56c67568cbe3d.svg";